import { trigger } from "../util/EventManager"

function ResetButton() {

  const reset = () => {
    trigger('reset')
  }

  return (
    <button id="btn-reset" className="button" onClick={reset}>Zurücksetzen</button>
  )
}

export default ResetButton